import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea } from '@ttstr/components';

const Releases: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article>
      <Container className="list-page my-5">
        <Helmet>
          <title>Music</title>
          <body className="releases-page" />
        </Helmet>
        <h1 className="mb-5">Music</h1>
        <ContentrArea id="releases-page-content" />
      </Container>
    </article>
  );
};

export default React.memo(Releases);
